<script setup lang="ts">
const productContent = useProductContentStore()
const { isAuthorized } = useAuth()
const loginPageUrl = useLoginPageUrl()
const products = useProductVariantsStore()

useHead({
  bodyAttrs: {
    class: "bg-platform-paper",
  },
})

const showArticleFooter = computed(() => {
  const template = productContent.activeArticle?.template

  return !(template && template === "USlidesArticle")
})

function scroll() {
  const article = Array.from(
    document.querySelectorAll("[id^=article-page-]"),
  ) as HTMLElement[]

  if (article.length) {
    const [page] = article
    page?.focus()
  }
}

const canGoBack = computed(
  () => !!(productContent.previousArticle?.id && !productContent.previousArticle?.restricted),
)

function goBack() {
  if (canGoBack.value) {
    if (productContent.previousArticle?.frontendHref) {
      navigateTo(productContent.previousArticle?.frontendHref)
    } else {
      console.warn(
        "Navigating to 404 page:'productContent.previousArticle?.frontendHref' is not defined",
        productContent.previousArticle?.frontendHref,
      )
      navigateTo({
        path: "/404",
        query: {
          r: "Vi fant ikke artikkelen du så etter",
        },
      })
    }
  }
}
function goForward() {
  if (productContent.nextArticle?.frontendHref) {
    navigateTo(productContent.nextArticle?.frontendHref)
  } else {
    console.warn(
      "Navigating to 404 page:'productContent.nextArticle?.frontendHref' is not defined",
      productContent.nextArticle?.frontendHref,
    )
    navigateTo({
      path: "/404",
      query: {
        r: "Vi fant ikke artikkelen du så etter",
      },
    })
  }
}
</script>

<template>
  <div
    id="article-layout"
    class="article-layout !bg-platform-paper outline-none"
    @keyup.esc="
      productContent.activeSubject?.frontendHref
        ? navigateTo(productContent.activeSubject?.frontendHref)
        : null
    "
    @keyup.exact.left="goBack"
    @keyup.exact.right="goForward"
    @keyup.up="scroll"
    @keyup.down="scroll"
  >
    <UArticleLoadingScreen
      v-if="productContent.hydrationInProgress"
    />

    <div
      class="grid h-dvh grid-rows-[0,minmax(0,1fr),max-content]"
    >
      <template v-if="productContent.noArticlesFound">
        <div class="richtext row-start-2 place-self-center">
          <h1>Fant ikke artikkelen</h1>
          <p v-if="!isAuthorized && loginPageUrl">
            Kanskje du ser den hvis du
            <NuxtLink :to="loginPageUrl">
              logger inn
            </NuxtLink>?
          </p>

          <NuxtLink class="mt-6 block" to="..">
            Ta meg til forsiden av Kunne
            {{ products.activeProduct?.productTitle ?? "" }}
          </NuxtLink>
        </div>
      </template>
      <template v-else>
        <UArticleNavigationTop
          v-if="productContent.activeArticle"
          :article="productContent.activeArticle"
          :go-back="goBack"
          :can-go-back="canGoBack"
        />
        <slot v-if="productContent.activeArticle" />
        <UArticleFooter v-if="showArticleFooter" />
      </template>
    </div>
  </div>
</template>
